import { PermissionLevel, RoleOption } from "@/api/workspace/types";

export const roleOptions: RoleOption[] = [
  { value: PermissionLevel.SA, label: "Support Agent" },
  { value: PermissionLevel.ADMIN, label: "Admin" },
  { value: PermissionLevel.OWNER, label: "Owner" },
];

export const getRoleByValue = (value: PermissionLevel): string => {
  return roleOptions.find((role) => role.value === value)?.label || "";
};
